<template>
  <el-form :model="form" ref="form" :rules="rules" v-on="$listeners" @submit="submit">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Название" prop="short_name">
          <el-input
            v-model="form.short_name"
            size="small"
            placeholder="Камера #1"
            :readonly="isReadOnly"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Адрес" prop="address">
          <el-input v-model="form.address" size="small" placeholder="Москва" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Владелец">
          <select-client
            :owner-id="form.id_account_master"
            v-if="$can('update', 'cameras') && !isCameraDeleted"
            @change="(client) => (form.id_account_master = client.id_account)"
          />
          <el-input v-else :value="camera.owner_client_name" type="text" readonly size="small" />
        </el-form-item>
      </el-col>
      <el-col v-if="$can('read', 'cameras_archive_depth')" :span="12">
        <el-form-item label="Тариф" prop="id_tariff">
          <select-tariff
            v-if="$can('update', 'cameras_archive_depth') && !isCameraDeleted"
            :tariff-id="id_tariff"
            @change="(tariff) => (id_tariff = tariff.id_tariff)"
          />
          <el-input v-else :value="camera.id_tariff" type="text" size="small" readonly />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Часовой пояс" prop="timezone">
          <br />
          <el-input-number
            style="width: 66%"
            :disabled="isReadOnly"
            id="timezone"
            v-model="form.timezone"
            :min="-12"
            :max="12"
            size="small"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Серийный номер" prop="serial_number" v-if="!isCreatedByStreamLink">
          <el-input
            id="serial_number"
            size="small"
            :value="camera.serial_number"
            readonly
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" v-if="$can('read', 'orgs') && !isCreatedByStreamLink">
        <el-form-item label="Юридическое лицо" prop="id_org">
          <select-org
            :disabled="isReadOnly"
            :org-id="form.id_org"
            @change="(org) => (form.id_org = org.id_org)"
            @clear="() => (form.id_org = null)"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item v-if="canSeeInstallationLocation" label="Место установки" prop="id_location">
          <el-select
            v-model="form.id_location"
            size="small"
            placeholder="Не указано"
            style="width: 100%"
            clearable
            :disabled="isReadOnly"
          >
            <el-option
              v-for="val in installationLocations"
              :key="val.id_location"
              :label="val.name_location"
              :value="val.id_location"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Инстанс" prop="id_md_instance">
          <el-select
            v-model="form.id_md_instance"
            size="small"
            placeholder="Не указано"
            style="width: 100%"
            clearable
            :disabled="isReadOnly"
          >
            <el-option
              v-for="val in motionDetectionInstances"
              :key="val.id_md_instance"
              :label="val.instance_name"
              :value="val.id_md_instance"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Имя камеры в детекции" prop="md_filter_value">
          <el-input v-model="form.md_filter_value" size="small" placeholder="(значение по-умолчанию)" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Детекция" prop="is_md_active">
          <el-switch
            v-model="form.is_md_active"
            :active-value="1"
            :inactive-value="0"
            :disabled="isReadOnly"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider v-if="isModelRtspCamera" />
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="IP адрес" prop="ip">
          <el-input v-model="form.ip" size="small" placeholder="1.1.1.1" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="!isCreatedByStreamLink">
      <el-col :span="20">
        <el-form-item label="Данные авторизации камеры">
          <show-parameter-button parameter="credentials" :is-parameter-showed="getIsParameterShowed('credentials')" :on-click="showParameter" />
        </el-form-item>
      </el-col>
    </el-row>
    <template v-if="getIsParameterShowed('credentials') && !isCreatedByStreamLink">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Логин" prop="login">
            <el-input size="small" v-model="form.login" :readonly="isReadOnly" style="margin-top: 4px">
              <el-tooltip slot="append" content="Скопировать">
                <el-button size="small" :disabled="block" @click="copyData(form.login)">
                  <fa :icon="['far', 'copy']" />
                </el-button>
              </el-tooltip>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Пароль" prop="password">
            <el-input
              size="small"
              show-password
              v-model="form.password"
              :readonly="isReadOnly"
              style="margin-top: 4px"
            >
              <el-tooltip slot="append" content="Скопировать">
                <el-button size="small" :disabled="block" @click="copyData(form.password)">
                  <fa :icon="['far', 'copy']" />
                </el-button>
              </el-tooltip>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Порт" prop="port">
            <el-input size="small" v-model.number="form.port" :readonly="isReadOnly" />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <el-divider v-if="isModelRtspCamera" />
    <el-row :gutter="20" v-if="isModelRtspCamera">
      <el-col :span="24">
        <el-form-item label="Серая RTSP ссылка">
          <show-parameter-button parameter="grey_rtsp_settings" :is-parameter-showed="getIsParameterShowed('grey_rtsp_settings')" :on-click="showParameter" />
          <el-input
            v-if="getIsParameterShowed('grey_rtsp_settings')"
            :value="form.grey_rtsp_link"
            size="small"
            placeholder="Серая RTSP ссылка"
            readonly
          >
            <el-tooltip slot="append" content="Скопировать">
              <el-button size="small" :disabled="!form.grey_rtsp_link" @click="copyData(form.grey_rtsp_link)">
                <fa :icon="['far', 'copy']" />
              </el-button>
            </el-tooltip>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="isModelRtspCamera && getIsParameterShowed('grey_rtsp_settings')">
      <el-col :span="12">
        <el-form-item label="Серый IP адрес" prop="grey_ip">
          <el-input v-model="form.grey_ip" size="small" placeholder="1.1.1.1" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="RTSP порт камеры" prop="rtsp_port">
          <el-input v-model.number="form.rtsp_port" size="small" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider v-if="isModelRtspCamera" />
    <el-row :gutter="20" v-if="!isModelRtspCamera">
      <el-col :span="24">
        <el-form-item label="Серая RTSP ссылка" prop="grey_rtsp_link">
          <show-parameter-button parameter="grey_rtsp_link" :is-parameter-showed="getIsParameterShowed('grey_rtsp_link')" :on-click="showParameter" />
          <el-input v-if="getIsParameterShowed('grey_rtsp_link')" v-model="form.grey_rtsp_link" size="small" placeholder="Серая RTSP ссылка" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Приоритет" prop="priority">
          <el-input v-model="priority" size="small" placeholder="Приоритет" readonly />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Публичный доступ" prop="publicAccess">
          <el-switch
            v-model="form.public_access"
            :active-value="1"
            :inactive-value="0"
            :disabled="isReadOnly"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Тип камеры" prop="is_push_camera">
          <el-switch
            v-model="form.is_push_camera"
            :active-value="1"
            :inactive-value="0"
            active-text="RTMP"
            inactive-text="RTSP"
            :disabled="isCameraTypeToggleDisabled"
            @change="onCameraTypeChange"
          />
          <el-tooltip v-if="camera.is_lvs === 1" :content="lvsTooltip" placement="top">
            <el-tag size="mini" type="info" class="camera-form__binding-tag">LinkVideo.Server</el-tag>
          </el-tooltip>
          <el-tag v-if="camera.is_lvb === 1" size="mini" type="info" class="camera-form__binding-tag">LinkVideo.Bridge</el-tag>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Камера заведена по ссылке">
          <el-switch :value="isCreatedByStreamLink" size="small" disabled :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="isCreatedByStreamLink">
        <el-form-item label="RTSP ссылка" prop="stream">
          <show-parameter-button parameter="stream" :is-parameter-showed="getIsParameterShowed('stream')" :on-click="showParameter" />
          <br />
          <el-input v-if="getIsParameterShowed('stream')" v-model="form.stream" size="small" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="$can('read', 'intercoms') && operatorCan()">
      <el-col :span="12">
        <el-form-item label="Домофон" prop="id_intercom">
          <select-intercom
            :intercom-id="form.id_intercom"
            @change="(intercom) => (form.id_intercom = intercom.id_intercom)"
            @clear="() => (form.id_intercom = null)"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider />
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="dvrServerLabel" prop="id_dvr_server">
          <el-input
            :style="$can('update', 'cameras_dvr_server') ? 'margin-top: 4px' : ''"
            id="password"
            size="small"
            :value="camera.server_name"
            readonly
          >
            <el-button
              v-if="$can('update', 'cameras_dvr_server') && !isCameraDeleted"
              slot="append"
              size="small"
              :disabled="block"
              @click="dialogDvr = true"
            >
              Изменить
            </el-button>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col v-if="$can('read', 'cameras_proxy_server')" :span="12">
        <el-form-item :label="proxyServerLabel" prop="id_proxy_server">
          <el-input
            :style="$can('update', 'cameras_proxy_server') ? 'margin-top: 4px' : ''"
            id="password"
            size="small"
            :value="camera.proxy_server_name"
            readonly
          >
            <el-button
              v-if="$can('update', 'cameras_proxy_server') && !isCameraDeleted"
              slot="append"
              size="small"
              :disabled="block"
              @click="dialogProxy = true"
            >
              Изменить
            </el-button>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="canMigrateMediaCore" :gutter="20">
      <el-col :span="24" style="text-align: right">
        <el-button
          size="small"
          :disabled="block"
          @click="dialogMigration = true"
        >
          <fa :icon="['fas', 'exchange-alt']" />
          Мигрировать на {{ targetMediaCoreName }}
        </el-button>
      </el-col>
    </el-row>
    <el-divider />
    <el-row :gutter="20">
      <el-col :span="10">
        <el-form-item label="Модель" prop="id_model" v-if="!isCreatedByStreamLink">
          <select-model
            :model-id="form.id_model"
            :camera-id="form.id_camera"
            :disabled="isReadOnly"
            @change="(model) => (form.id_model = model.id_model)"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="Mute" prop="mute_sound">
          <el-switch
            v-model="form.mute_sound"
            :disabled="isReadOnly"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <!-- ТЗ 3.2: на ВК 3.0 сервер сам определяет необходимость транскода, поэтому флаг
           не показываем. Вместе с ним прячем и выбор side-task`а: он управляется этим
           же признаком, и без него оставался бы селект без видимой причины. -->
      <el-col v-if="!isVk3" :span="10">
        <el-form-item label="Необходимость транскодинга звука" prop="need_sound">
          <el-switch
            v-model="form.need_sound"
            :disabled="!!form.mute_sound || isReadOnly"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </el-col>
      <el-col v-if="!isVk3" :span="8">
        <el-form-item prop="id_sidetask_setting" label="Тип side-task`а" v-if="form.stream && form.need_sound">
          <select-model-side-task-type :selected="form.id_sidetask_setting" @change="onSidetaskChange" :disabled="isReadOnly" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider v-if="camera.is_onvif && !form.is_push_camera" />
    <el-row :gutter="20" v-if="camera.is_onvif && !form.is_push_camera">
      <el-col :span="20">
        <el-form-item label="Данные ONVIF">
          <show-parameter-button parameter="credentials_onvif" :is-parameter-showed="getIsParameterShowed('credentials_onvif')" :on-click="showParameter" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="camera.is_onvif && !form.is_push_camera && getIsParameterShowed('credentials_onvif')">
      <el-col :span="8">
        <el-form-item label="Порт ONVIF" prop="port_onvif">
          <el-input size="small" v-model.number="form.port_onvif" :readonly="isReadOnly"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="Логин ONVIF" prop="login_onvif">
          <el-input style="margin-top: 4px" size="small" v-model="form.login_onvif" :readonly="isReadOnly">
            <el-tooltip slot="append" content="Скопировать">
              <el-button size="small" :disabled="block" @click="copyData(form.login_onvif)">
                <fa :icon="['far', 'copy']" />
              </el-button>
            </el-tooltip>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="Пароль ONVIF" prop="password_onvif">
          <el-input style="margin-top: 4px" size="small" show-password v-model="form.password_onvif" :readonly="isReadOnly">
            <el-tooltip slot="append" content="Скопировать">
              <el-button size="small" :disabled="block" @click="copyData(form.password_onvif)">
                <fa :icon="['far', 'copy']" />
              </el-button>
            </el-tooltip>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="camera.is_onvif && !form.is_push_camera && getIsParameterShowed('credentials_onvif')">
      <el-col :span="8">
        <el-form-item label="Время движения" prop="move_duration_default">
          <el-input size="small" v-model.number="form.move_duration_default" :readonly="isReadOnly" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="Настройка даты ONVIF" prop="set_camera_onvif_datetime">
          <br />
          <el-button
            class="page__active_button"
            style="float: left; margin: 5px 0 0; width: 100%"
            size="small"
            :disabled="isReadOnly"
            @click="dialogSetDatetime = true"
          >
            Изменить
          </el-button>
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider />
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="Комментарий" prop="description">
          <el-input
            v-model="form.description"
            size="small"
            placeholder="Какое-то описание, которое видно только в админке"
            :readonly="isReadOnly"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider />
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Дата создания" prop="created_at">
          <el-input size="small" :value="camera.created_at" readonly />
        </el-form-item>
      </el-col>
    </el-row>
    <dvr-server-dialog
      :id-server="camera.id_dvr_server"
      :id-media-core="mediaCore"
      :id-proxy-server="camera.id_proxy_server"
      :is-rrtsp="camera.is_rrtsp"
      :visible="dialogDvr"
      :loading="fetch"
      @close="dialogDvr = false"
      @save="onUpdateDvrServer"
    />
    <proxy-server-dialog
      :id-server="camera.id_proxy_server"
      :id-media-core="mediaCore"
      :id-dvr-server="camera.id_dvr_server"
      :visible="dialogProxy"
      :loading="fetch"
      @close="dialogProxy = false"
      @save="onUpdateProxyServer"
    />
    <media-core-migration-dialog
      v-if="mediaCore"
      :id-media-core="mediaCore"
      :visible="dialogMigration"
      :loading="fetch"
      @close="dialogMigration = false"
      @save="onMigrateMediaCore"
    />
    <CameraOnvifDatetimeEdit
      :id_camera="camera.id_camera"
      :visible.sync="dialogSetDatetime"
      @close="dialogSetDatetime = false"
    />
  </el-form>
</template>

<script>
import { faVideo, faSave, faTrash, faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import {
  length,
  required,
  validatorOptionalIp,
  validatorNoDollar,
  validatorIntegerRange,
  sideTaskRequired,
  validatorNumberRange,
} from "@/core/helpers/validators";
import { mapActions, mapMutations, mapState } from "vuex";
import mapKey from "@/core/helpers/mapKey";
import { MEDIA_CORE, MEDIA_CORE_NAME } from "@/core/helpers/const";
import copyBuffer from "@/core/mixins/copyBuffer";
import DvrServerDialog from "@/components/Server/feature/DvrServerDialog";
import ProxyServerDialog from "@/components/Server/feature/ProxyServerDialog";
import MediaCoreMigrationDialog from "@/components/Server/feature/MediaCoreMigrationDialog";
import SelectClient from "@/core/components/features/SelectClient";
import SelectModel from "@/core/components/features/SelectModel";
import SelectTariff from "@/components/Tariffs/components/feature/SelectTariff";
import SelectIntercom from "@/core/components/features/SelectIntercom";
import SelectOrg from "@/components/Orgs/components/feature/SelectOrg";
import CameraOnvifDatetimeEdit from "@/components/Cameras/components/Camera/features/CameraOnvifDatetimeEdit";
import SelectModelSideTaskType from "@/core/components/SelectCameraSidetask";
import ShowParameterButton from "@/core/components/features/ShowParameterButton";
import { DEFAULT_RTSP_PORT, normalizeRtspPort, prepareGreyRtspPayload } from "../greyRtsp";

library.add(faSave, faTrash, faCopy, faExchangeAlt);

/* Камера заведена по RTSP-ссылке: для неё достаточно самой ссылки, логин/модель не нужны */
const isStreamLinkCamera = (component) => !!component.camera.is_created_by_stream_link;

/* Поля, обязательные для осознанного перевода RTMP-камеры на RTSP.
   Проверяем их только на фронте (без жёстких ограничений на бэкенде), чтобы оператор
   сразу видел, чего не хватает для переключения. */
const switchRequired = (component, label, appliesWhen = () => true) => ({
  validator: (rules, value, callback) => {
    if (
      component.isSwitchingToRtsp()
      && appliesWhen(component)
      && (value === null || value === undefined || value === "")
    ) {
      callback(new Error(`Для перехода на RTSP заполните «${label}»`));
      return;
    }
    callback();
  },
  trigger: "change",
});

export default {
  name: "CameraForm",
  components: {
    SelectTariff,
    SelectClient,
    SelectModel,
    SelectIntercom,
    DvrServerDialog,
    ProxyServerDialog,
    MediaCoreMigrationDialog,
    SelectOrg,
    CameraOnvifDatetimeEdit,
    fa,
    SelectModelSideTaskType,
    ShowParameterButton,
  },
  mixins: [copyBuffer],
  props: {
    hiddenFields: {
      type: Array,
      default: () => [],
    },
    requestParameter: {
      type: Function,
      default: () => {},
    },
    getIsParameterShowed: {
      type: Function,
      default: () => {},
    },
    revealRtspFields: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      transcode_audio: 0,
      dialogSetDatetime: false,
      dialogDvr: false,
      dialogProxy: false,
      dialogMigration: false,
      fetch: false,
      block: false,
      preserveUnsavedForm: false,
      /* true только на время подгрузки RTSP-параметров при переводе камеры на RTSP */
      preserveCameraTypeChoice: false,
      id_tariff: null,
      priority: null,
      installationLocations: [],
      motionDetectionInstances: [],
      isCreatedByStreamLink: 0,
      info: {
        owner_login: "",
        server_name: "",
      },
      form: {
        id_camera: null,
        id_account_master: null,
        id_md_instance: null,
        short_name: "",
        address: "",
        description: "",
        timezone: "",
        ip: "",
        login: "",
        password: "",
        is_push_camera: null,
        id_model: null,
        need_sound: false,
        mute_sound: false,
        port: 554,
        id_intercom: null,
        id_org: null,
        port_onvif: null,
        login_onvif: null,
        password_onvif: null,
        is_onvif: null,
        move_duration_default: null,
        is_return_sldp_links: 1,
        disable_sub_stream: 0,
        stream: "",
        id_sidetask_setting: 1,
        public_access: 0,
        id_location: "",
        is_md_active: 0,
        md_filter_value: "",
        grey_rtsp_link: "",
        grey_ip: "",
        rtsp_port: DEFAULT_RTSP_PORT,
      },
      rules: this.$can("update", "cameras")
        ? {
          short_name: [required(), length(3, 64)],
          address: [length(3, 200)],
          ip: [switchRequired(this, "IP-адрес камеры", (c) => !isStreamLinkCamera(c))],
          id_account_master: [required("number")],
          description: [length(0, 300)],
          login: [validatorNoDollar, switchRequired(this, "логин камеры", (c) => !isStreamLinkCamera(c))],
          password: [validatorNoDollar, switchRequired(this, "пароль камеры", (c) => !isStreamLinkCamera(c))],
          timezone: [required("number")],
          is_push_camera: [],
          id_model: [switchRequired(this, "модель камеры", (c) => !isStreamLinkCamera(c))],
          need_sound: [],
          mute_sound: [],
          port: [switchRequired(this, "порт камеры", (c) => !isStreamLinkCamera(c))],
          id_intercom: [],
          id_org: [],
          port_onvif: [],
          login_onvif: [],
          password_onvif: [],
          is_onvif: [],
          move_duration_default: [],
          is_return_sldp_links: [validatorNumberRange(0, 1)],
          disable_sub_stream: [validatorNumberRange(0, 1)],
          stream: [length(7, 2048), switchRequired(this, "RTSP-ссылку", isStreamLinkCamera)],
          id_sidetask_setting: [sideTaskRequired(() => this.form.stream && this.form.need_sound, "number")],
          public_access: [validatorNumberRange(0, 1)],
          grey_rtsp_link: [length(0, 300)],
          grey_ip: [validatorOptionalIp],
          rtsp_port: [validatorIntegerRange(1, 65535)],
        }
        : null,
    };
  },
  computed: {
    isModelRtspCamera() {
      return !this.camera.is_push_camera && !this.camera.is_created_by_stream_link && !!this.camera.id_model;
    },
    isCameraDeleted() {
      return this.camera.is_deleted !== undefined ? this.camera.is_deleted === 1 : false
    },
    isReadOnly() {
      return !this.$can('update', 'cameras') || this.isCameraDeleted
    },
    isCameraTypeToggleDisabled() {
      return this.isReadOnly
        || this.camera.is_push_camera === 0
        || this.camera.is_rrtsp === 1;
    },
    lvsTooltip() {
      return `Привязана к LVS «${this.camera.lvs_server_name || ''}»`;
    },
    canSeeInstallationLocation() {
      let idOperator = localStorage.getItem("operator");
      return ["241", "2", "341"].includes(idOperator);
      /* костыль, чтобы показывать выбор места установки только в linkvideo (241), TestOperator2 (2), reserv (341),
      нужно переделать, когда будет горизонтальное разграничение прав операторов */
    },
    ...mapState("cameras", {
      camera: (state) => state.camera,
      owners: (state) => state.owners,
      model: (state) => state.model,
    }),
    // Платформа камеры — это платформа её DVR-сервера: карточка отдаёт её полем server_id_media_core.
    mediaCore() {
      const idMediaCore = this.camera.server_id_media_core;
      return Object.values(MEDIA_CORE).includes(idMediaCore) ? idMediaCore : null;
    },
    isVk3() {
      return this.mediaCore === MEDIA_CORE.VK3;
    },
    dvrServerLabel() {
      return this.isVk3 ? "ArchCore" : "DVR-сервер";
    },
    proxyServerLabel() {
      return this.isVk3 ? "MCore" : "Прокси-сервер";
    },
    targetMediaCoreName() {
      return MEDIA_CORE_NAME[this.isVk3 ? MEDIA_CORE.VK2 : MEDIA_CORE.VK3];
    },
    canMigrateMediaCore() {
      return Boolean(
        this.mediaCore
        && !this.isCameraDeleted
        && this.$can("update", "cameras_dvr_server")
        && this.$can("update", "cameras_proxy_server")
      );
    },
  },
  watch: {
    "form.id_server_cluster"() {
      this.getRecommend(this.form.id_server_cluster);
    },
    camera(camera, previousCamera) {
      this.fetchDataCamera(this.preserveUnsavedForm ? previousCamera : null);
    },
    "form.id_model"() {
      if (this.form.id_model > 0)
        this.getModel(this.form.id_model)
          .then(() => {
            this.transcode_audio = this.model.transcode_audio
          })
    },
    "form.mute_sound"(val) {
      if (val) {
        this.form.need_sound = 1;
      }
    },
  },
  created() {
    this.getInstallationLocations()
      .then((res) => {
          this.installationLocations = res
        }
      );
    this.getMotionDetectionInstances()
      .then((res) => {
          this.motionDetectionInstances = res
        }
      );
    /* Если камера уже в сторе (перезаход на страницу), сразу синхронизируем форму,
       чтобы не показывать незасохранённое/пустое состояние тогла типа камеры */
    if (this.camera && this.camera.id_camera) {
      this.fetchDataCamera();
    }
  },
  methods: {
    ...mapActions("cameras", {
      updateDvrServer: "UPDATE_DVR_SERVER",
      updateCamera: "UPDATE_CAMERA",
      updateTariff: "UPDATE_TARIFF",
      updateProxyServer: "UPDATE_PROXY_SERVER",
      migrateMediaCore: "MIGRATE_MEDIA_CORE",
      getModel: "GET_MODEL",
      getInstallationLocations: "GET_CAMERA_INSTALLATION_LOCATIONS",
      getMotionDetectionInstances: "GET_MOTION_DETECTION_INSTANCES",
    }),
    ...mapMutations("cameras", {
      setCamera: "SET_CAMERA",
      setCameraPublishUrls: "SET_CAMERA_PUBLISH_URLS",
    }),
    onSidetaskChange(setting) {
      this.form.id_sidetask_setting = setting.id_sidetask_setting;
    },
    showParameter(parameter) {
      this.preserveUnsavedForm = true;
      return Promise.resolve(this.requestParameter(parameter))
        .finally(() => {
          this.$nextTick(() => {
            this.preserveUnsavedForm = false;
          });
        });
    },
    onCameraTypeChange(value) {
      /* Показываем RTSP-поля при осознанном переводе push-камеры на RTSP.
         Пока идёт подгрузка параметров, не даём маппингу камеры сбросить выбранный тип. */
      if (value === 0 && this.camera.is_push_camera === 1) {
        this.preserveCameraTypeChoice = true;
        Promise.resolve(this.revealRtspFields())
          .then(() => this.$nextTick())
          .finally(() => {
            this.preserveCameraTypeChoice = false;
          });
      }
    },
    fetchDataCamera(previousCamera) {
      if (previousCamera) {
        Object.keys(this.form).forEach((key) => {
          if (this.camera[key] !== previousCamera[key]) {
            this.form[key] = this.camera[key];
          }
        });
        return;
      }

      /* Тип камеры задаётся свитчем пользователя. Сохраняем уже выбранный тип только пока
         подгружаем RTSP-параметры для переключения; в остальных случаях синхронизируем с камерой,
         чтобы незасохранённый выбор не «залипал» при перезагрузке данных. */
      const isPushCameraChoice = this.form.is_push_camera;
      mapKey(this.form, this.camera);
      if (
        this.preserveCameraTypeChoice
        && this.camera.is_push_camera === 1
        && isPushCameraChoice !== null
        && isPushCameraChoice !== undefined
      ) {
        this.form.is_push_camera = isPushCameraChoice;
      }
      mapKey(this.info, this.camera);
      this.isCreatedByStreamLink = this.camera.is_created_by_stream_link;
      /* need_sound обязателен на бэкенде при переводе на RTSP — приводим nullable-значение к 0/1 */
      if (this.form.need_sound !== 0 && this.form.need_sound !== 1) {
        this.form.need_sound = this.form.need_sound ? 1 : 0;
      }
      this.id_tariff = this.camera.id_tariff;
      this.priority = this.camera.priority;

      // this.rules.ip = this.camera.is_push_camera === 0 ? [required("string"), validatorIp] : []
    },
    onUpdateDvrServer(idDvrServer, force) {
      this.fetch = true;

      this.updateDvrServer({ id: this.camera.id_camera, id_dvr_server: idDvrServer, force })
        .then((camera) => {
          this.dialogDvr = false;

          this.$message({
            message: `Сервер ${this.dvrServerLabel} успешно изменен.`,
            type: "success",
          });

          this.setCamera(camera);
        })
        .catch((e) => {
          const { data } = e.response;
          this.$message({
            message: `${data.error}. Код ошибки: ${data.code}`,
            type: "error",
          });
        })
        .catch(() => {
          this.$message({
            message: "Неизвестная ошибка.",
            type: "error",
          });
        })
        .finally(() => {
          this.fetch = false;
        });
    },
    onUpdateProxyServer(idProxyServer) {
      this.fetch = true;

      this.updateProxyServer({ id: this.camera.id_camera, id_proxy_server: idProxyServer })
        .then((camera) => {
          this.dialogProxy = false;

          this.$message({
            message: `Сервер ${this.proxyServerLabel} успешно изменен.`,
            type: "success",
          });

          this.setCamera(camera);
        })
        .catch((e) => {
          const { data } = e.response;
          this.$message({
            message: `${data.error}. Код ошибки: ${data.code}`,
            type: "error",
          });
        })
        .catch(() => {
          this.$message({
            message: "Неизвестная ошибка.",
            type: "error",
          });
        })
        .finally(() => {
          this.fetch = false;
        });
    },
    onMigrateMediaCore(idDvrServer, idProxyServer) {
      this.fetch = true;

      this.migrateMediaCore({
        id: this.camera.id_camera,
        id_server: idDvrServer,
        id_proxy_server: idProxyServer,
      })
        .then((camera) => {
          this.dialogMigration = false;
          this.setCamera(camera);
          this.$message.success(`Камера успешно мигрирована на ${MEDIA_CORE_NAME[camera.server_id_media_core] || "новую платформу"}.`);
        })
        .catch((error) => {
          const data = error.response && error.response.data;
          this.$message.error(data ? `${data.error}. Код ошибки: ${data.code}` : "Неизвестная ошибка.");
        })
        .finally(() => {
          this.fetch = false;
        });
    },
    isSwitchingToRtsp() {
      return this.camera.is_push_camera === 1 && this.form.is_push_camera === 0;
    },
    validateForm() {
      return new Promise((resolve) => {
        this.$refs["form"].validate((valid) => resolve(valid));
      });
    },
    getSwitchConfirmText() {
      if (this.camera.is_lvs === 1) {
        return `Камера будет отвязана от LinkVideo.Server «${this.camera.lvs_server_name || ''}», LVS перестанет пушить поток. Продолжить?`;
      }
      return "Публикация в proxy будет остановлена, поток начнёт забираться напрямую по RTSP. Продолжить?";
    },
    async submit(event) {
      event.preventDefault();

      if (this.isSwitchingToRtsp()) {
        /* Явная ошибка на фронте: не отправляем запрос, пока не заполнены поля для RTSP */
        const valid = await this.validateForm();
        if (!valid) {
          this.$message.error("Заполните поля для RTSP — иначе камера не сможет переключиться");
          return;
        }

        try {
          await this.$confirm(this.getSwitchConfirmText(), "Подтверждение", {
            confirmButtonText: "Переключить",
            cancelButtonText: "Отмена",
            type: "warning",
          });
        } catch (e) {
          return;
        }
      }

      this.fetch = true;

      const isGreyRtspSettingsShown =
        this.isModelRtspCamera && this.getIsParameterShowed("grey_rtsp_settings");
      const idCamera = this.camera.id_camera;
      const hiddenFields = [...this.hiddenFields];

      if (isGreyRtspSettingsShown) {
        this.form.rtsp_port = normalizeRtspPort(this.form.rtsp_port);
      }

      // TODO сделать отдельные формы
      if (this.id_tariff !== this.camera.id_tariff) {
        await this.updateTariff({
          id: this.camera.id_camera,
          id_tariff: this.id_tariff,
        });
      }

      if (this.camera.is_return_sldp_links !== undefined) {
        this.form.is_return_sldp_links = this.camera.is_return_sldp_links;
      }

      if (this.camera.disable_sub_stream !== undefined) {
        this.form.disable_sub_stream = this.camera.disable_sub_stream;
      }

      const editedCamera = {
        ...prepareGreyRtspPayload(this.form, this.isModelRtspCamera),
        hidden_fields: hiddenFields,
      };

      if (!(this.form.rtsp_stream !== "" && this.form.need_sound)) {
        delete editedCamera.id_sidetask_setting;
      }

      await this.$refs["form"].validate((valid) => {
        if (valid) {
          this.updateCamera({
            id: idCamera,
            data: editedCamera,
          })
            .then((data) => {
              this.$message({
                message: "Информация обновлена",
                type: "success",
              });

              this.setCamera(data);
            })
            .catch((e) => {
              this.$message.error(e?.response?.data?.error || "Ошибка при обновлении информации о камере");
            })
            .finally(() => {
              this.fetch = false;
            });
          return valid;
        } else {
          this.fetch = false;
        }
      });
    },
    operatorCan() {
      return localStorage.getItem("operator") == 621 || localStorage.getItem("operator") == 1021;
    },
  },
};
</script>

<style lang="postcss">
.camera-form__binding-tag {
  margin-left: 8px;
}
</style>
